module.exports = __webpack_public_path__ + "static/media/Societe-Valorisation-Immobilier-Vaud.24e399fc.jpg";